import React from 'react';
import HeartBubble from './HeartBubble';
import { Sparkles } from 'lucide-react';

const Hero = () => {
  return (
    <section
      id="home"
      className="relative bg-charcoal pt-28 pb-20 md:pt-36 md:pb-24 overflow-hidden"
    >
      {/* Floating heart bubbles */}
      <HeartBubble
        size={140}
        className="top-24 left-[6%] float-anim hidden md:block"
        rotate={-12}
      />
      <HeartBubble
        size={90}
        className="top-56 left-[18%] float-anim-delay hidden md:block"
        rotate={8}
      />
      <HeartBubble
        size={70}
        className="top-12 right-[10%] float-anim hidden lg:block"
        rotate={-4}
      />
      <HeartBubble
        size={100}
        className="bottom-20 right-[6%] float-anim-delay hidden md:block"
        rotate={12}
      />

      <div className="max-w-5xl mx-auto px-6 relative z-10 text-center">
        <p className="text-yellow font-heavy uppercase tracking-wide text-sm md:text-base mb-5 inline-flex items-center gap-2">
          <Sparkles className="w-4 h-4" />
          LLIT-Media — Content That Moves.
        </p>
        <h1 className="font-display text-white text-[44px] sm:text-6xl md:text-8xl leading-[0.95]">
          Content <span className="text-yellow">That</span>{' '}
          <span className="text-yellow">Moves.</span>
        </h1>
        <p className="mt-7 text-zinc-200 text-lg md:text-xl max-w-2xl mx-auto">
          <span className="text-yellow font-bold">Social Media Agentur</span>{' '}
          – Kreativ. Strategisch. Sichtbar.
        </p>
        <div className="mt-9">
          <a href="#contact" className="btn-yellow">
            Kostenlos anfragen
          </a>
        </div>

        <div className="mt-12 inline-flex items-baseline gap-3 px-6 py-4 rounded-lg border-2 border-yellow/40 bg-yellow/5">
          <span className="font-display text-yellow text-4xl md:text-5xl">10 Mio.+</span>
          <span className="text-zinc-200 text-sm md:text-base font-medium">
            Views generiert für Unternehmen
          </span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
